import { gql } from '@apollo/client';
import { menuList } from '../fragments/menuList';

export const getGlobalMenuListQuery = gql`
query GetGlobalMenuList{
 MenuListHeader(usePreview: false,tags:"advertisingGlobalMenu" ) {
   internalName
  menuSections{
    itemUrl
    itemIcon
    publicName
    internalName
  }
  
  }
}
`;
